import React from "react";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useStyles} from "./NewReferenceItemPriceButton.style";
import {useI18nContext} from "../../../contexts/I18nContext";
import {useCommonContext} from "../../../contexts/CommonContext";
import useOnEnterPress from "../../../hooks/EnterPress";
import Icon from "../../../ui_components/Icon/Icon";
import IconName from "../../../ui_components/Icon/enums/IconName";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Button from "../../../ui_components/Button/Button";
import {Observer} from "mobx-react-lite";
import Modal from "../../../ui_components/Modal/Modal";
import InventoryItemNameInput from "../../Inputs/InventoryItem/InventoryItemNameInput/InventoryItemNameInput";
import NewReferenceItemPriceButtonProperties from "./NewReferenceItemPriceButtonProperties";
import NewReferenceItemPriceButtonStore from "./NewReferenceItemPriceButtonStore";
import InventoryItemDescriptionInput from "../../Inputs/InventoryItem/InventoryItemDescriptionInput/InventoryItemDescriptionInput";
import PriceInput from "../../Inputs/PriceInput/PricetInput";
import ShowText from "../../Info/ShowText/ShowText";
import { CurrencyModule } from "../../../util/Currency";

const NewReferenceItemPriceButton:React.FC<NewReferenceItemPriceButtonProperties> = ({
                                                                                               onClick = () => {},
                                                                                               onSave = () => {},
                                                                                               showIcon = true,
                                                                                               showText = true,
                                                                                               disabled,
                                                                                               className = '',
                                                                                               rounded = false,
                                                                                               size = ButtonSize.DEFAULT,
                                                                                               type = ButtonType.DEFAULT,
                                                                                               customButton = null,
                                                                                               referenceItemId
}) => {

    const classes = useStyles(showText);
    const i18n = useI18nContext();
    const commonContext = useCommonContext();

    const store = new NewReferenceItemPriceButtonStore(commonContext,referenceItemId)

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }
    const onCloseModal = () => {
        store.closeModal();
    }
    const onReferenceItemSave = async () => {
        const saved = await store.save()
        if(saved) {
            store.closeModal()
            if (onSave){
                onSave(store.referenceItemPriceResponse)
            }
        }
    }


    const onNameChange = async (newName: string) => { await store.setNewName(newName)}
    const onDescriptionChange = async (newDescription: string) => { await store.setNewDescription(newDescription)}
    const onAmountChange = async (newAmount: number) => { await store.setNewAmount(newAmount)}
    
    useOnEnterPress(onReferenceItemSave,[store])

    const text = i18n.translate((store.isEditing ? "EDIT_REFERENCE_ITEM" : "NEW_REFERENCE_ITEM"));
    const btnIcon = store.isEditing ? <Icon name={IconName.EDIT_ICON}/> : <Icon name={IconName.CREATE_ICON}/>;

    const Btn = () => {
        if (customButton !=null){
            return <div className={classes.custom_button_container} onClick={handleOnclick}>{customButton}</div>;
        }
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? btnIcon : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? btnIcon : <></>}
        />
    }

    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={text} onClose={onCloseModal}
                       open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        <InventoryItemNameInput
                            error={i18n.translate(store.nameError)}
                            fullWidth
                            className={classes.input}
                            required = {true}
                            value={store.referenceItemPriceResponse?.referenceItemName}
                            onChange={onNameChange}/>
                        <InventoryItemDescriptionInput
                            error={i18n.translate(store.nameError)}
                            fullWidth
                            className={classes.input}
                            value={store.referenceItemPriceResponse?.referenceItemDescription}
                            onChange={onDescriptionChange}/>
                        <ShowText title={"Cost"} text={CurrencyModule.format(store.referenceItemPriceResponse.cost) }/>
                        <PriceInput
                            label={i18n.translate("INVENTORY_ITEM_DEFAULT_CUSTOM_PRICE")}
                            value={store.referenceItemPriceResponse.amount}
                            onChange={onAmountChange}/>
                        <div className={classes.btn_container}>
                            <Button
                                disabled={!store.enableButton}
                                loading={store.loading} className={classes.input} onClick={onReferenceItemSave}
                                type={ButtonType.SECONDARY}
                                text={i18n.translate("SAVE")}/>
                            <Button
                                loading={store.loading} className={classes.cancel_btn} onClick={onCloseModal}
                                type={ButtonType.DEFAULT}
                                text={i18n.translate("CANCEL")}/>
                        </div>
                    </div>
                </Modal>
                <Btn/>
            </>
        )}
    </Observer>
}
export default NewReferenceItemPriceButton